import { MESSAGE_DETAIL } from '../constants/MessageConst';

const initialState = {};

const messageDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case MESSAGE_DETAIL:
      return {
        ...state,
        messageDetail: action.payload,
      };
    default:
      return state;
  }
};
export default messageDetailReducer;
